export default function DSA_Bubble_Sort() {
  return <div>DSA_Bubble_Sort Component</div>;
}
